exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".discard {\r\n  width: 20em;\r\n  height: 28.625em;\r\n\r\n  font-size: 6px;\r\n\r\n  position: absolute;\r\n}\r\n.discard.shuffle {\r\n  animation: shuffle 500ms ease-in-out 1 forwards;\r\n  z-index: 10;\r\n}\r\n@keyframes shuffle {\r\n  0% {\r\n    transform: initial;\r\n    opacity: 1;\r\n  }\r\n  49% {\r\n    opacity: 1;\r\n  }\r\n  50% {\r\n    opacity: 0;\r\n  }\r\n  100% {\r\n    transform: translateX(23em) rotateY(-180deg) skewX(-6deg);\r\n    opacity: 0;\r\n  }\r\n}\r\n", ""]);

// exports
